import React from "react";

function FaqTopic(props) {
  const handleRadioChange = (event) => {
    const selectedValue = event.target.value;
    const { setSubjectFilter } = props;
    setSubjectFilter(selectedValue); // Assuming setSubjectFilter is passed as a prop
  };

  return (
    <>
      <div className="faq-topics">
        <h3>Filter by topic</h3>
        <div className="radio-group">
          <input
            className="form-check-input"
            type="radio"
            name="radioGroup"
            id="radioGroup0"
            value="all"
            defaultChecked
            onChange={handleRadioChange}
          />
          <label className="form-check-label" htmlFor="radioGroup0">
            All topics
          </label>
        </div>
        <div className="radio-group">
          <input
            className="form-check-input"
            type="radio"
            name="radioGroup"
            id="radioGroup1"
            value="aboutcamp"
            onChange={handleRadioChange}
          />
          <label className="form-check-label" htmlFor="radioGroup1">
            About CAMP
          </label>
        </div>
        <div className="radio-group">
          <input
            className="form-check-input"
            type="radio"
            name="radioGroup"
            id="radioGroup2"
            value="locationtravel"
            onChange={handleRadioChange}
          />
          <label className="form-check-label" htmlFor="radioGroup2">
           Location & travel
          </label>
        </div>
        <div className="radio-group">
          <input
            className="form-check-input"
            type="radio"
            name="radioGroup"
            id="radioGroup3"
            value="onsiteworkshops"
            onChange={handleRadioChange}
          />
          <label className="form-check-label" htmlFor="radioGroup3">
            Onsite workshops
          </label>
        </div>
        <div className="radio-group">
          <input
            className="form-check-input"
            type="radio"
            name="radioGroup"
            id="radioGroup4"
            value="onlineworkshops"
            onChange={handleRadioChange}
          />
          <label className="form-check-label" htmlFor="radioGroup4">
            Online workshops
          </label>
        </div>
        <div className="radio-group">
          <input
            className="form-check-input"
            type="radio"
            name="radioGroup"
            id="radioGroup5"
            value="residencies"
            onChange={handleRadioChange}
          />
          <label className="form-check-label" htmlFor="radioGroup5">
            Self-guided residencies
          </label>
        </div>
        <div className="radio-group">
          <input
            className="form-check-input"
            type="radio"
            name="radioGroup"
            id="radioGroup6"
            value="mentorship"
            onChange={handleRadioChange}
          />
          <label className="form-check-label" htmlFor="radioGroup6">
            Mentorship
          </label>
        </div>
        <div className="radio-group">
          <input
            className="form-check-input"
            type="radio"
            name="radioGroup"
            id="radioGroup7"
            value="payments"
            onChange={handleRadioChange}
          />
          <label className="form-check-label" htmlFor="radioGroup7">
            Payments, refunds & grants
          </label>
        </div>
        <div className="radio-group">
          <input
            className="form-check-input"
            type="radio"
            name="radioGroup"
            id="radioGroup8"
            value="releasesradiopublications"
            onChange={handleRadioChange}
          />
          <label className="form-check-label" htmlFor="radioGroup8">
            Releases, radio & publications
          </label>
        </div>
      </div>
    </>
  );
}

export default FaqTopic;
